import { Button, Input } from "@abios/smorgasbord-components"
import styled from "styled-components"

export const DomainModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const DomainModalContentContainer = styled.div`
  flex-grow: 1;
  max-height: 500px;
  overflow-y: auto;
  padding-bottom: 1rem;
`

export const DomainDeleteButton = styled.button`
  padding: 0.25rem;
  margin: 0;
  border-radius: var(--border-radius-2);
  transition: background-color 100ms;

  &:hover {
    background-color: var(--red-100);
  }

  &:active {
    background-color: var(--red-200);
  }
`

export const CreateDomainRow = styled.div`
  display: flex;
  gap: 0.5rem;
  padding-bottom: 1rem;

  & > span {
    width: 100%;
  }
`

export const CreateDomainInput = styled(Input)`
  span:has(+ &) {
    width: 100%;
  }
`

export const ModalActionButton = styled(Button)`
  width: 100%;
`

export const ModalErrorText = styled.p`
  font-size: var(--text-50);
  color: var(--alert-text-color-error);
`
